import React from 'react';

class TabBar extends React.Component {

    constructor(props) {
      super(props);
    }

    selected() {
        return this.props.tabs.indexOf(this.props.tab)
    }

    classAtIndex(i) {
        return ( i==this.selected() )?' tab_item_selected':''
    }

    onClick(i) {
        this.props.setTab(this.props.tabs[i])
    }

    render() {

        return <div className='tab_container'>
            {this.props.tabs.map(
                (tab,i) => {
                    return <div 
                    className={'tab_item'+this.classAtIndex(i)} 
                    onClick={this.onClick.bind(this,i)}
                    key={i}
                >
                    {tab}
                </div>
                }
            )}
            {this.props.children}
        </div>
    }
}

export default TabBar;